// @ts-expect-error Could not find a declaration file for module

// @ts-expect-error Could not find a declaration file for module

// @ts-expect-error Could not find a declaration file for module

// @ts-expect-error Could not find a declaration file for module
import ExpandedTrackNavigator from './ExpandedTrackNavigator';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackNavigator = ({
  exam,
  currentContentId,
  lessons,
  track,
  trackIntroductionVideo
}) => /*#__PURE__*/_jsx("div", {
  className: "track-navigator",
  "data-test-id": "track-navigator",
  children: !track || !lessons ? /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 100
  }) : /*#__PURE__*/_jsx(ExpandedTrackNavigator, {
    currentContentId: currentContentId,
    exam: exam,
    lessons: lessons,
    track: track,
    trackIntroductionVideo: trackIntroductionVideo
  })
});
export default TrackNavigator;